import Phaser from 'phaser';
import { Player } from '../entities/Player';
import { Enemy } from '../entities/Enemy';

export class BaseProjectile extends Phaser.Physics.Arcade.Sprite {
  public damage: number = 0;

  hit(): void {
    this.destroy();
  }
}

export abstract class BaseWeapon {
  protected scene: Phaser.Scene;
  protected player: Player;
  protected enemies: Phaser.Physics.Arcade.Group;
  protected projectiles: Phaser.Physics.Arcade.Group;
  protected damageMultiplier: number = 1;
  protected attackTimer?: Phaser.Time.TimerEvent;

  constructor(scene: Phaser.Scene, player: Player, enemies: Phaser.Physics.Arcade.Group, projectileClassType: any) {
    this.scene = scene;
    this.player = player;
    this.enemies = enemies;

    this.projectiles = scene.physics.add.group({
      classType: projectileClassType,
      runChildUpdate: true
    });

    this.setupCollision();
  }

  protected setupCollision(): void {
    this.scene.physics.add.overlap(
      this.projectiles,
      this.enemies,
      (proj, enemy) => {
        const projectile = proj as BaseProjectile;
        const target = enemy as Enemy;

        if (projectile.active && target.active) {
          target.takeDamage(projectile.damage);
          projectile.hit();
        }
      }
    );
  }

  public updateDamageMultiplier(multiplier: number): void {
    this.damageMultiplier = multiplier;
  }

  public destroy(): void {
    if (this.attackTimer) {
      this.attackTimer.destroy();
    }
    this.projectiles.clear(true, true);
  }

  protected abstract attack(): void;
  protected abstract startAutoAttack(): void;
}
